import { Directive, forwardRef, Attribute } from "@angular/core";
import { Validator, AbstractControl, NG_VALIDATORS } from "@angular/forms";

@Directive({
  selector:
    "[repeatpassword][formControlName],[repeatpassword][formControl],[repeatpassword][ngModel]",
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => RepeatPasswordValidator),
      multi: true,
    },
  ],
})
export class RepeatPasswordValidator implements Validator {
  constructor(@Attribute("repeatpassword") public repeatpassword: string) {}

  validate(c: AbstractControl): { [key: string]: any } {
    // self value (e.g. retype password)
    const v = c.value;

    // control value (e.g. password)
    const e = c.root.get(this.repeatpassword);

    // value not equal
    // tslint:disable-next-line:curly
    if (e && v !== e.value)
      return {
        repeatPassword: false,
      };
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/app/_directives/repeatpassword.validator.ts